import IndustryBenefitsI18n from "@/components/landing/shared/IndustryBenefitsI18n";
import { TrendingUp, Heart, PiggyBank, Users } from "lucide-react";
const VorteileITSection = () => <IndustryBenefitsI18n translationPrefix="industryIT" icons={[TrendingUp, Heart, PiggyBank, Users]} />;
export default VorteileITSection;
